import { Box, CircularProgress, Paper, Tab, Tabs, Typography } from "@mui/material"
import { alpha } from "@mui/material/styles"
// RaffleDetail.js
import React, { useEffect, useState } from "react"
import { doc, getDoc } from "firebase/firestore"

import FixTickets from "../FixTickets"
import RaffleAssetsManager from "./RaffleAssetsManager"
import { RaffleEditView } from "./RaffleEditView"
// import TermsIcon from "./raffle/TermsIcon"
import Wheel from "../Wheel"
import RaffleTickets from "./RaffleTickets"
import { db } from "../../firebase"
import { useParams } from "react-router-dom"
import { EmptyComponent } from "react-ui-components/components/EmptyComponent"
import RaffleUsers from "./RaffleUsers"

const RaffleDetail = () => {
  const { id }: any = useParams()
  const [raffle, setRaffle] = useState<any>(null)
  const [value, setValue] = useState(0)

  useEffect(() => {
    const fetchRaffle = async () => {
      const docRef = doc(db, "raffles", id)
      const docSnap = await getDoc(docRef)
      if (docSnap.exists()) {
        setRaffle({ id: docSnap.id, ...docSnap.data() })
      }
    }
    fetchRaffle()
  }, [id])

  if (!raffle) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: 320 }}>
        <CircularProgress />
      </Box>
    )
  }

  const handleChange = (event: any, newValue: React.SetStateAction<number>) => {
    setValue(newValue)
  }

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "min(100%, 1800px)",
        mx: "auto",
      }}
    >
      <Paper
        elevation={0}
        sx={(theme) => ({
          overflow: "hidden",
          borderRadius: 4,
          border: "1px solid",
          borderColor: "divider",
          background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.08)}, ${alpha(
            theme.palette.secondary.main,
            0.07,
          )} 44%, ${theme.palette.background.paper} 76%)`,
        })}
      >
        <Box
          sx={(theme) => ({
            position: "sticky",
            top: 64,
            zIndex: 2,
            px: { xs: 1, md: 2 },
            pt: { xs: 1.5, md: 2 },
            background: alpha(theme.palette.background.paper, 0.88),
            backdropFilter: "blur(14px)",
            borderBottom: "1px solid",
            borderColor: "divider",
          })}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            aria-label="Raffle detail tabs"
            sx={{
              minHeight: 56,
              "& .MuiTab-root": {
                minHeight: 52,
                borderRadius: 3,
                fontWeight: 800,
                textTransform: "none",
                px: { xs: 1.5, md: 3 },
                color: "text.secondary",
              },
              "& .Mui-selected": {
                backgroundColor: alpha("#1976d2", 0.12),
                color: "primary.main",
                boxShadow: (theme) => `inset 0 0 0 1px ${alpha(theme.palette.primary.main, 0.24)}`,
              },
              "& .MuiTabs-indicator": {
                height: 3,
                borderRadius: 999,
              },
            }}
          >
            <Tab label="Details" {...a11yProps(0)} />
            <Tab label="Content" {...a11yProps(1)} />
            <Tab label="Drawing" {...a11yProps(2)} />
            <Tab label="Tickets" {...a11yProps(3)} />
            <Tab label="Users" {...a11yProps(4)} />
            <Tab label="Tools" {...a11yProps(5)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          {!raffle ? (
            <EmptyComponent />
          ) : (
            <RaffleEditView
              raffle={raffle}
              onRaffleSaved={(updatedRaffle) =>
                setRaffle((prev: any) => ({ ...prev, ...updatedRaffle }))
              }
            />
          )}
        </TabPanel>
        <TabPanel value={value} index={1}>
          <RaffleAssetsManager raffleId={id} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <Box sx={{ pt: { xs: 1.5, md: 2 } }}>{!id ? null : <Wheel raffleId={id} />}</Box>
        </TabPanel>
        <TabPanel value={value} index={3}>
          <RaffleTickets raffle={raffle} />
        </TabPanel>
        <TabPanel value={value} index={4}>
          <RaffleUsers raffleId={id} raffle={raffle} />
        </TabPanel>
        <TabPanel value={value} index={5}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Tools
          </Typography>
          <FixTickets raffle={raffle} />
        </TabPanel>
      </Paper>
    </Box>
  )
}

function TabPanel(props: { [x: string]: any; children: any; value: any; index: any }) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: { xs: 2, md: 3 } }}>{children}</Box>}
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  }
}

export default RaffleDetail
